module.exports = __webpack_public_path__ + "img/img_13.2ce0060e.jpg";